/**
 * SearchService - Handles athlete search functionality
 */

import * as d3 from 'd3';
import { AthleteData } from '../types/athlete.types';
import { StageNumber } from '../types/stage.types';

export class SearchService {
    /**
     * Searches for an athlete in filtered data
     */
    findAthleteInData(searchTerm: string, filteredData: AthleteData[]): AthleteData | null {
        const bibNumber = parseInt(searchTerm);
        const isValidBib = !isNaN(bibNumber) && bibNumber > 0;

        if (isValidBib) {
            return filteredData.find(d => d.Bib === bibNumber) || null;
        } else {
            const searchLower = searchTerm.toLowerCase();
            return filteredData.find(d =>
                d.Name && d.Name.toLowerCase().includes(searchLower)
            ) || null;
        }
    }

    /**
     * Finds athlete across all stages to get their characteristics
     */
    findAthleteAcrossStages(
        bibNumber: string,
        allData: Map<StageNumber, AthleteData[]>
    ): AthleteData | null {
        const bib = parseInt(bibNumber);
        if (isNaN(bib)) return null;

        for (let stage = 1; stage <= 5; stage++) {
            const stageData = allData.get(stage as StageNumber);
            if (stageData) {
                const athlete = stageData.find(d => d.Bib === bib);
                if (athlete) return athlete;
            }
        }

        return null;
    }

    /**
     * Auto-applies filters based on athlete characteristics
     */
    applyFiltersForAthlete(athlete: AthleteData): void {
        d3.select<HTMLSelectElement, unknown>('#category-filter')
            .property('value', athlete.Event);
        d3.select<HTMLSelectElement, unknown>('#distance-filter')
            .property('value', athlete.Distance);
        // Keep age group as "all" - don't auto-apply
    }
}
